'use client';

import { AlertType, AlertVariant } from '@constants/alert';

class AlertManager {
    constructor() {
        if (AlertManager.instance) {
            return AlertManager.instance;
        }

        this.config = {
            type: AlertType.ALERT,
            options: {
                variant: AlertVariant.NEUTRAL,
                title: "",
                text: "",
                okLabel: "",
                cancelLabel: "",
            },
            okHandler: null,
            cancelHandler: null
        }

        AlertManager.instance = this;
        return this;
    }

    openAlert(options) {
        this.config.type = AlertType.ALERT;
        this.config.options = options;
        this.config.cancelHandler = null;
        this.config.okHandler = null;
    }

    openConfirm(options, cancel, ok) {
        this.config.type = AlertType.CONFIRM;
        this.config.options = options;
        this.config.cancelHandler = cancel ? () => cancel() : null;
        this.config.okHandler = ok ? () => ok() : null;
    }

    getConfig() {
        return this.config;
    }
}

const alertManager = new AlertManager();
export default alertManager;